import { createSelector } from 'reselect';
import { v2 } from '@saucelabs/sl-module-builds';

import { eventMetaDataSelector } from '../common/selectors';

const selectSlice = (store) => store.apps.jobs.flatBuilds.rdc;

export const selectBuilds = v2.buildsList.selectors.createBuildListSelector(selectSlice);

export const automatedRDCBuildsSelector = createSelector([
  (store) => store.apps.jobs.flatBuilds.common,
  selectSlice,
  selectBuilds,
  eventMetaDataSelector,
],
(common, slice, buildList, eventMetaData) => ({
  buildsLoading: common.get('rdcBuildsLoading'),
  rdcBuilds: buildList,
  rdcExpandedBuilds: slice.get('expandedBuilds'),
  rdcFailedJobs: slice.get('failedJobs'),
  eventMetaData: {
    ...eventMetaData,
    sku_type: 'RDC',
  },
}));

export const getUsername = v2.buildsList.selectors.createGetUsername(selectSlice);
